import {
  FieldMapping,
  Mapping,
} from '@teetsh/app/src/containers/Eleves/Import/File/csv';
import isUUID from 'validator/lib/isUUID';

export function getMappingItem(
  mappings: Mapping[] | null,
  field: FieldMapping,
): Mapping | undefined {
  if (!mappings || mappings.length === 0) {
    return undefined;
  }
  return mappings.find(m => m.mapping === field);
}

export function getCustomFields(mappings: Mapping[] | null): Mapping[] {
  return (mappings || []).filter(m => isUUID(m.mapping));
}
